module.exports = __webpack_public_path__ + "static/media/default-profile-avatar.9acfe78b.png";